









































import {
  Component,
  Prop,
  Watch,
  Vue,
  ProvideReactive,
} from "vue-property-decorator";
import NotfallmangementApi from "../api/api-vfmt";
import Vorfallmanagement from "../api/Vorfallmanagement";
import { TabBaseVfmt } from "../tabs/Tab-Base-vfmt";
import spinner from "@/components/Spinner.vue";
import TabErfassungVfmt from "../tabs/Tab-Erfassung-vfmt.vue";
import TabRechtlicheBeurteilungVfmt from "../tabs/Tab-Rechtliche-Beurteilung-vfmt.vue";
import TabAufgabenVfmt from "../tabs/Tab-Aufgaben-vfmt.vue";
import TabKorrespondenzVfmt from "../tabs/Tab-Korrespondenz-vfmt.vue";

@Component({
  components: {
    spinner,
    TabErfassungVfmt,
    TabRechtlicheBeurteilungVfmt,
    TabAufgabenVfmt,
    TabKorrespondenzVfmt,
  },
})
export default class extends Vue {
  private readonly api = new NotfallmangementApi();
  @Prop() private readonly id!: number;
  private vorfall: Vorfallmanagement.Vorfall | null = null;
  @ProvideReactive("listen") private listen: Vorfallmanagement.Listen | null =
    null;

  public async load() {
    try {
      if (this.id) {
        const [vorfall, listen] = await Promise.all([
          this.api.GetVorfall(this.id),
          this.api.GetListen(),
        ]);
        this.vorfall = { ...vorfall };
        this.listen = { ...listen };
      }
    } catch (error) {
      throw error;
    }
  }

  beforeMount() {
    this.load();
  }
}
